var app = angular.module("nms.dwdmCircuits", []); // NOSONAR

app.config(["$translatePartialLoaderProvider", function($translatePartialLoader) {
    $translatePartialLoader.addPart("features/topology/dwdm-circuit");
}]);

app.run(["$translate", function($translate) {
        $translate.refresh();
    }
]);
